function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS AppSideNav INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import filterChildren from "../../../../utils/Children/filterChildren";
var UUAppSideNav = function UUAppSideNav(props) {
  var id = props.id,
    className = props.className,
    children = props.children,
    style = props.style,
    width = props.width,
    navContent = props.navContent,
    containerStyle = props.containerStyle,
    mainContentStyle = props.mainContentStyle,
    opened = props.opened,
    containerClassName = props.containerClassName;
  var appSideNavContainerClass = classNames({
    'flex transition-transform duration-500 transition-width duration-500': true,
    'w-full': opened
  }, containerClassName);
  var appBarSideNavClass = classNames({
    'flex-none flex-grow-0 flex-shrink-0 w-60': true
  }, className);
  var appBarSideNavMainClass = classNames({
    'flex-auto': true
  });
  var newChildren = filterChildren(children);
  return /*#__PURE__*/React.createElement("div", {
    className: appSideNavContainerClass,
    style: _objectSpread(_objectSpread({}, containerStyle), {}, {
      width: opened ? '100%' : "calc(100% + ".concat(width, ")"),
      transform: opened ? 'translateX(0)' : "translateX(-".concat(width, ")")
    })
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: appBarSideNavClass,
    style: style
  }, navContent), /*#__PURE__*/React.createElement("div", {
    className: appBarSideNavMainClass,
    style: mainContentStyle
  }, newChildren));
};
UUAppSideNav.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for sidebar nav */
  className: PropTypes.string,
  /** styles for the sidebar nav */
  style: PropTypes.object,
  /** className for container of the side nav */
  containerClassName: PropTypes.string,
  /** styles for container of the side nav */
  containerStyle: PropTypes.object,
  /** styles for the main content */
  mainContentStyle: PropTypes.object,
  /** width of the side bar nav */
  width: PropTypes.string,
  /** content inside of the nav side bar */
  navContent: PropTypes.node.isRequired,
  /** if true, nav side bar will show */
  opened: PropTypes.bool,
  /**
  * children props for content inside
  * @ignore
  */
  children: PropTypes.node
};
UUAppSideNav.defaultProps = {
  id: '',
  className: '',
  containerClassName: '',
  containerStyle: {},
  children: [],
  style: {},
  navContent: null,
  mainContentStyle: {},
  opened: false,
  width: '250px'
};
export default UUAppSideNav;